import { createStore, } from 'vuex';
import { markRaw } from 'vue';
import { ElMessageBox } from 'element-plus';

import router from '@/router';
import resetRouter from '@/router/resetRouter';

import { loginOut } from '@/api/Login';

import { code, code1, code2, offline,code4, submitCode, preCode } from '@/../static/config';
const configJson = __IS__OFFLINE__ ? offline : preCode;

export default createStore({
  state: {
    /**
     * 配置项
     */
    defaultRootURL: configJson.defaultRootURL,
    imgURL: configJson.imgURL,
    targetDetectionImgURL: configJson.targetDetectionImgURL,
    musicURL: configJson.musicURL,
    geoserverURL: configJson.geoserverURL,
    openResourceURL: configJson.openResourceURL,
    /**
     * 地图配置
     */
    map_config: {
      center: [34.3227, 88.5525],
      zoom: 4,
      minZoom: 1,
      maxZoom: 18,
    },
    mapBoxToken: "pk.eyJ1IjoiZXhhbXBsZXMiLCJhIjoiY21rbzVreHNrMDJ2NDNlbXhudTkxMGI3aiJ9.0zBA_9egcHq59cvlpytLoA",
    mapBoxURL: "https://api.mapbox.com/styles/v2/{id}/tiles/{z}/{x}/{y}",
    isLogin: localStorage.getItem('isLogin'),
    homeMap: undefined,
    roleName: localStorage.getItem('roleName') || '',
    loginInfoKey: [
      { localKey: 'userToken', userKey: 'token' },
      { localKey: 'userName', userKey: 'user' },
      { localKey: 'roleName', userKey: 'roleName' },
      { localKey: 'isLogin', userKey: undefined },
      { localKey: 'remainingDays', userKey: 'remainingDays' },
    ],
    selectedNode: null,
    selectedMap: null,

    // 每日线索区
    todayExposureShowFlag: true,
    // 每日线索区图例
    todayExposureLegendList: [],
    // 每日线索区图例 - Map
    todayExposureLegendMap: new Map,
    // 每日线索区图例 - 不显示的类型列表
    exposureNoShowList: ['线索区', '应急拍摄区'],
    // 工作模式（工作台编辑）
    isWorkMode: false,
    // 首页导航栏
    isCollapsed: false,
    // 是否在首页
    isHomePage: true,
    // 自定义区域 - 是否在首页操作
    isHomeCustomLayer: undefined,
    // 自定义区域
    isCustomLayer: true,
    // 活动热图
    eventHeatMapShowFlag: false,
    // 特殊底图默认层级
    tileDefaultZIdex: 10,
    // 线索区数据
    clueAreaList: [],
    // 区域保存接口
    polySubmitPort: undefined,
    // 持续跟踪 - 名录
    regionDirectoryShowFlag: true,
    // 工作台当前底图ID
    workBenchMapId: undefined,
  },
  getters: {
    defaultRootURL: (state) => { return state.defaultRootURL; },
    imgURL: (state) => { return state.imgURL; },
    targetDetectionImgURL: (state) => { return state.targetDetectionImgURL; },
    musicURL: (state) => { return state.musicURL; },
    geoserverURL: (state) => { return state.geoserverURL; },
    openResourceURL: (state) => { return state.openResourceURL; },
    getMapBoxToken: (state) => { return state.mapBoxToken; },
    getMapBoxURL: (state) => { return state.mapBoxURL; },
    getMapConfig: (state) => { return state.map_config; },
    getIsLogin: (state) => { return state.isLogin; },
    getHomeMap: (state) => { return state.homeMap; },
    getSelectedNode(state) { return state.selectedNode; },
    getSelectedMap(state) { return state.selectedMap; },
    todayExposureShowFlag: (state) => { return state.todayExposureShowFlag; },
    isWorkMode: (state) => state.isWorkMode,
    isHomePage: (state) => state.isHomePage,
    isHomeCustomLayer: (state) => state.isHomeCustomLayer, //首页自定义图层
    isCustomLayer: (state) => state.isCustomLayer,
    isCollapsed: (state) => state.isCollapsed,
    eventHeatMapShowFlag: (state) => state.eventHeatMapShowFlag,
    tileDefaultZIdex: (state) => state.tileDefaultZIdex,
    clueAreaList: (state) => state.clueAreaList,
    todayExposureLegendList: (state) => state.todayExposureLegendList,
    todayExposureLegendMap: (state) => state.todayExposureLegendMap,
    exposureNoShowList: (state) => state.exposureNoShowList,
    polySubmitPort: (state) => state.polySubmitPort,
    regionDirectoryShowFlag: (state) => state.regionDirectoryShowFlag,
    workBenchMapId: (state) => state.workBenchMapId,
    roleName: (state) => state.roleName,
    isSuperAdmin: (state) => state.roleName === '超级管理员',
  },
  mutations: {
    regionDirectoryShowFlagChange(state, flag) {
      state.regionDirectoryShowFlag = flag;
    },
    workBenchMapIdChange(state, mapId) {
      state.workBenchMapId = mapId;
    },
    polySubmitPortChange(state, fn) {
      state.polySubmitPort = fn;
    },
    todayExposureLegendListClear(state) {
      state.todayExposureLegendList.splice(0);
    },
    todayExposureLegendListAdd(state, item) {
      state.todayExposureLegendList.push(item);
    },
    todayExposureLegendMapClear(state) {
      state.todayExposureLegendMap.clear();
    },
    todayExposureLegendMapSet(state, { type, item }) {
      state.todayExposureLegendMap.set(type, item);
      this.commit('todayExposureLegendMapUpdate');
    },
    todayExposureLegendMapUpdate(state){
      state.todayExposureLegendMap = new Map(state.todayExposureLegendMap);
    },
    clueAreaListInner(state, list) {
      state.clueAreaList.push(...list);
    },
    clueAreaListClear(state) {
      state.clueAreaList.splice(0);
    },
    eventHeatMapShowFlagChange(state, flag) {
      state.eventHeatMapShowFlag = flag;
    },
    isCustomLayerChange(state, flag) {
      state.isCustomLayer = flag;
    },
    isHomeCustomLayerChange(state, flag) {
      state.isHomeCustomLayer = flag;
    },
    isCollapsedChange(state, flag) {
      state.isCollapsed = flag;
    },
    isHomePageChange(state, flag) {
      state.isHomePage = flag;
    },
    isWorkModeChange(state, flag) {
      state.isWorkMode = flag;
    },
    todayExposureShowFlagChange(state, flag) {
      state.todayExposureShowFlag = flag;
    },
    isLoginChange(state, flag) {
      state.isLogin = flag;
    },
    loginInfo(state, data) {
      state.loginInfoKey.forEach((item => {
        if (!item.userKey) {
          return;
        }
        if (item.userKey === 'roleName') {
          state.roleName = data[item.userKey]
        }
        localStorage.setItem(item.localKey, data[item.userKey]);
      }))

      localStorage.setItem("isLogin", true);
      this.commit('isLoginChange', true);
    },
    localDataClear(state) {
      state.roleName = '';
      state.loginInfoKey.forEach((item => {
        localStorage.removeItem(item.localKey);
      }))
    },
    setHomeMap(state, mapInstance) {
      state.homeMap = mapInstance ? markRaw(mapInstance) : undefined;
    },
    setSelectedNode(state, node) {
      state.selectedNode = node;
    },
    setSelectedMap(state, node) {
      state.selectedMap = node;
    },
    removeSelectedNode(state) {
      state.selectedNode = null;
    },
    removeSelectedMap(state) {
      state.selectedMap = null;
    }
  },
  actions: {
    loginInfo(store, data) {
      return new Promise((resolve, reject) => {
        store.commit('loginInfo', data);
        resolve();
      })
    },
    loginOut(store) {
      ElMessageBox.confirm(
        '是否退出当前账户？',
        '退出',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      ).then(res => {
        loginOut({}).then(res => {
          if (res.data.code == 1004) {
            store.dispatch('loginOutNoCheck');
            store.commit('homeTile/mapClose');
          }
        }).catch(err => {
          console.log(err);
        });
      }).catch(err => {
        console.log(err);
      });
    },
    loginOutNoCheck(state) {
      this.commit('localDataClear');
      this.commit('isLoginChange', false);
      this.commit('permissions/clearMenuList');
      this.commit('permissions/clearRouteList');
      resetRouter();
      router.push('/Login');
    },
  },
  modules: {
    permissions,
    themeScheme,
    mdEditor,
    leafletPolygon,
    homeTile,
  },
});
import { message } from '@/utils/js/initVariable';

import permissions from './modules/permissions';
import themeScheme from './modules/themeScheme';
import mdEditor from './modules/mdEditor';
import leafletPolygon from './modules/leafletPolygon';
import homeTile from './modules/homeTile'

